
export const SET_PATIENT = 'SET_PATIENT';
export const GET_PATIENTS = 'GET_PATIENT_LIST';
export const FETCHING_LIST = 'FETCHING_LIST';
export const SET_PATIENT_FORM = 'SET_PATIENT_FORM';
export const RESET_PATIENT = 'RESET_PATIENT';
export const SET_ERROR = 'SET_ERROR';
export const RESET_ERROR = 'RESET_ERROR';

const initialState = {
  patient: null,
  list: null,
  fetched: false,
  fetching: false,
  formPatient: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PATIENT:
      return {
        ...state,
        patient: action.payload,
      };
    case GET_PATIENTS:
      return {
        ...state,
        fetched: true,
        fetching: false,
        list: action.payload,
      };
    case FETCHING_LIST:
      return {
        ...state,
        fetching: true,
      };
    case SET_PATIENT_FORM:
      return {
        ...state,
        formPatient: action.payload,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case RESET_ERROR:
      return {
        ...state,
        error: null,
      };
    case RESET_PATIENT:
      return {
        ...state,
        formPatient: null,
        patient: null,
        fetched: false,
        fetching: false,
        list: null,
        error: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/patient.js